import $ from "jquery";
import Glide from '@glidejs/glide';
export default class Carousel {
    static mount() {
        $(function () {
            Carousel.enableSliders();
        });
    }
    static enableSliders() {
        $('.glide').each(function () {
            const $this = $(this);
            $this.parent().addClass("carousel-mounted");
            const settings = $this.data("settings");
            let type = settings.type ? settings.type : 'carousel';
            let bound = settings.bound != undefined ? settings.bound : false;
            if ($(".glide__slide", $this).length <= 1) {
                $this.addClass('glide--disabled');
                return;
            }
            let glideSettings = {
                type: type,
                bound: bound,
                startAt: settings.startAt != undefined ? settings.startAt : 0,
                focusAt: settings.focusAt != undefined ? settings.focusAt : 0,
                rewind: settings.rewind != undefined ? settings.rewind : true,
                gap: settings.gap ? settings.gap : 10,
                perView: settings.perView > 0 ? settings.perView : 1,
                autoplay: settings.autoplay > 0 ? parseInt(settings.autoplay) * 1000 : false,
                hoverpause: settings.hoverpause != undefined ? settings.hoverpause : false,
                breakpoints: {}
            };
            if (settings.breakpoints) {
                glideSettings.breakpoints = settings.breakpoints;
            }
            new Glide(this, glideSettings).mount();
            const resizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    var element = entry.target;
                    const $firstSlideImage = $(".glide__slide:first-of-type  .glide-button-position-ref", element);
                    const height = $firstSlideImage.height();
                    if (height !== undefined) {
                        element.style.setProperty("--ce-glide__arrow-top", (height * 0.5) + "px");
                    }
                    else {
                        element.style.setProperty("--ce-glide__arrow-top", "50%");
                    }
                }
            });
            resizeObserver.observe(this);
        });
    }
}
